import styled from '@emotion/styled';
import { Button, Typography } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import pathToRegexp from 'path-to-regexp';
import { createElement, useContext, useEffect } from 'react';

import Spinner from '../../component/compound/Spinner';
import VideoScreen from '../../component/primitive/VideoScreen';
import { context as ConfigContext } from '../../context/config';
import { context as DependencyContext } from '../../context/dependency';
import { context as StateContext } from '../../context/state';
import { PLACEMENT_IMAGE_ENUM } from '../../page/AdSearchPage';

export const AdSearchDetail: React.FC = () => {
  const config = useContext(ConfigContext);
  const store = useContext(StateContext);
  const { adSearchUsecase } = useContext(DependencyContext);
  const { adSearch } = store;
  const { selectedVideos } = adSearch;
  const data = selectedVideos ? selectedVideos[0] : null;

  useEffect(() => {
    // すでにデータがあるときは取得しない. 詳細URLに直接来訪した時にURLに含まれるIDを元にデータを取得する
    if (data) {
      return;
    }
    const regexp = pathToRegexp('/search/:id');
    const urlObject = regexp.exec(window.location.pathname);
    // urlObject => ["/search/DE01EG1CHJDSMR", "DE01EG1CHJDSMR", index: 0, input: "/search/DE01EG1CHJDSMR", groups: undefined]
    if (!urlObject || urlObject.length < 1) {
      throw new Error('invalid url');
    }
    const creativeId = urlObject[1];
    adSearchUsecase.setSelectedCardDataByIds([creativeId]);
    // TODO: Implementation before introducing rules
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return data ? (
    <div>
      {data.fileUrl ? (
        <Video controls src={data.fileUrl} preloadAttr="metadata" />
      ) : (
        <img src={data.thumbnailUrl} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      )}
      <div style={{ padding: 12, display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', marginTop: 12, alignItems: 'center', justifyContent: 'space-between' }}>
          {data.optimizerProfileImageUrl ? (
            <a
              href={`${config.PROFILE_WEB_URL}/users/${data.optimizerId}`}
              target="_blank"
              rel="noreferrer"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <GhIcon src={data.optimizerProfileImageUrl} />
            </a>
          ) : (
            <DummyIcon />
          )}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ marginRight: 12 }}>{data.placement && PLACEMENT_IMAGE_ENUM[data.placement]}</div>
            <div>{data.aspectRatio}</div>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Button
            style={{ marginTop: 12, width: 160 }}
            onClick={() => {
              adSearchUsecase.moveToSearch();
            }}
          >
            <Typography style={{ color: 'white' }}>閉じる</Typography>
          </Button>
          <Button
            onClick={() => {
              adSearchUsecase.moveToCreateNewProject();
            }}
            style={{ marginTop: 12 }}
          >
            <AddCircleIcon style={{ marginRight: 12, color: '#4C566C' }} />
            <Typography>動画を制作する</Typography>
          </Button>
        </div>
      </div>
    </div>
  ) : (
    <div>
      <Spinner />
    </div>
  );
};

const GH_ICON_RADIUS = 48;

const Video = styled(VideoScreen)`
  width: 100%;
  height: 100%;
`;

const GhIcon = styled('img')({
  width: `${GH_ICON_RADIUS}px`,
  height: `${GH_ICON_RADIUS}px`,
  borderRadius: `${GH_ICON_RADIUS / 2}px`,
  border: 'solid 1px #ccc',
});

const DummyIcon = styled(AccountCircle)({
  width: `${GH_ICON_RADIUS}px`,
  height: `${GH_ICON_RADIUS}px`,
  borderRadius: `${GH_ICON_RADIUS / 2}px`,
  color: 'gray',
  backgroundColor: 'white',
});
